export const EMAIL_VARIFICATION_REQUEST = "EMAIL_VARIFICATION_REQUEST";
export const EMAIL_VARIFICATION_SUCCESS = "EMAIL_VARIFICATION_SUCCESS";
export const EMAIL_VARIFICATION_ERROR = "EMAIL_VARIFICATION_ERROR";
export const emailVarificationRequest = (accessToken) => ({
  type: EMAIL_VARIFICATION_REQUEST,
  accessToken,
});

export const emailVarificationSuccess = () => ({
  type: EMAIL_VARIFICATION_SUCCESS,
});

export const emailVarificationError = (error) => ({
  type: EMAIL_VARIFICATION_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/pages/confirmemail/actions.js